export function PageSpinner() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="h-10 w-10 animate-spin rounded-full border-4 border-surface border-t-royal-orange" />
    </div>
  );
}
